import { RejectSolid } from '@icons';
import React, { ReactNode } from 'react';
import { Button, Modal } from 'react-bootstrap';

interface RejectModalProps {
    message: ReactNode;
    show: boolean;
    onHide: () => void;
    tryAgain?: () => void;
}

const RejectModal: React.FC<RejectModalProps> = (
    { message, show, onHide, tryAgain }
) => {
    return <Modal
        show={show}
        onHide={() => {
            onHide();
        }}
        centered
        className="supermodal"
        backdropClassName="supermodal-backdrop"
    >
        <Modal.Header
            style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '16px',
            }}
        >
            <RejectSolid style={{ margin: '8px' }} />
            <h3
                style={{
                    fontSize: '24px',
                    textAlign: 'center',
                    lineHeight: '35px',
                    marginBottom: 0,
                    fontWeight: 700,
                }}
            >
                Qualcosa è andato storto!
            </h3>
        </Modal.Header>
        <Modal.Body
            style={{
                padding: '0 16px',
            }}
        >
            <p
                style={{
                    textAlign: 'center',
                    marginBottom: 0,
                    lineHeight: '28px',
                }}
            >
                {message}
            </p>
        </Modal.Body>
        <Modal.Footer>
            <Button
                className="btn custom-outline-button"
                style={{
                    width: '100%',
                    height: '48px',
                }}
                onClick={() => {
                    onHide();
                }}
            >
                Chiudi
            </Button>
            <p style={{ width: '100%', textAlign: 'center', margin: '1rem 0' }}>Oppure</p>
            <Button
                onClick={() => {
                    onHide();
                    tryAgain && tryAgain();
                }}
                className="btn custom-primary-button"
                style={{
                    width: '100%',
                    height: '48px',
                }}
            >
                Riprova
            </Button>
        </Modal.Footer>
    </Modal>
}

export default RejectModal